import * as React from "react";

import { H3, PaddedSurface, Paragraph } from "App/global-style";

import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { useTexts } from "Components/TextContext";
import { Button } from "Components/TextContext/commonComponentEnums";
import { ThemedButton } from "Components/Themes/components/ThemedButton";
import { ReduxState } from "Store/rootReducer";
import { buttonTrackId } from "Utils/analytics";
import { useSelector } from "react-redux";
import { DefaultLogin } from "../DefaultLogin";

export const HouseDefaultLogin = (): React.ReactElement => {
  const [showForm, setShowForm] = React.useState(false);
  const { getText } = useTexts();

  const { userIdentification } = useSelector((state: ReduxState) => state);
  const validNameNin = userIdentification.current?.newCustomerResponse?.isValid;

  return (
    <PaddedSurface>
      <H3>{getText("houseform.subheader.findyourhousemanually")}</H3>
      <Paragraph>
        {getText("houseform.description.findyourhousemanually")}
      </Paragraph>
      {!showForm && (
        <ThemedButton
          variant="outlined"
          trackId={buttonTrackId("login-without-bankid")}
          onClick={() => setShowForm(true)}
        >
          {getText(Button.NIN)}
        </ThemedButton>
      )}

      {showForm && (
        <DefaultLogin
          productBackendName={ProductBackendName.CAR}
          isLoading={userIdentification.isLoading}
          validNameNin={validNameNin}
          showBankIdMotivation={false}
        />
      )}
    </PaddedSurface>
  );
};
